export const FilterOrigins = (label, datas, id) => {
    const collection = [];
    const map = new Map();
    const sortDatas = (datas) => {
        datas.sort((a, b) => {
            if (a.oslug < b.oslug) return -1;
            if (a.oslug > b.oslug) return 1;
            return 0;
        });
    }
    if (datas.errno) {
        return collection;
    }
    switch (label) {
        case 'home':
            for (const el of datas) {
                if (!map.has(el.oslug)) {
                    map.set(el.oslug, true);
                    collection.push({
                        oid: el.oid, oname: el.oname, oslug: el.oslug,
                        oroute: el.oroute, ocreated: el.ocreated,
                    });
                }
            }
            sortDatas(collection);
            break;
        case 'park':
            for (const el of datas) {
                if (!map.has(el.oslug) && el.pid === id) {
                    map.set(el.oslug, true);
                    collection.push({
                        oid: el.oid, oname: el.oname, oslug: el.oslug,
                        oroute: el.oroute, ocreated: el.ocreated,
                    });
                }
            }
            sortDatas(collection);
            break;
        case 'univers':
            for (const el of datas) {
                if (!map.has(el.oslug) && el.uid === id) {
                    map.set(el.oslug, true);
                    collection.push({
                        oid: el.oid, oname: el.oname, oslug: el.oslug,
                        oroute: el.oroute, ocreated: el.ocreated,
                    });
                }
            }
            sortDatas(collection);
            break;
        case 'rencontres':
        case 'characters':
            for (const el of datas) {
                if (!map.has(el.oslug)) {
                    map.set(el.oslug, true);
                    collection.push({
                        oname: el.oname, oslug: el.oslug, oroute: el.oroute
                    });
                }
            }
            sortDatas(collection);
            break;
        default:
            return;
    }
    return collection;
}
